// Altura do teclado que cobre a tela no Android. Com a tela "de ponta a ponta" (Android 15+ e Expo atual),
// o sistema não encolhe a tela quando o teclado sobe: a tela precisa abrir espaço sozinha.
import { useEffect, useState } from 'react';
import { Dimensions, Keyboard, Platform } from 'react-native';

/** Quanto o teclado sobe acima da barra de navegação do sistema (0 com o teclado fechado). Some ao ins.bottom. */
export function useTecladoAndroid() {
  const [alt, setAlt] = useState(0);
  useEffect(() => {
    if (Platform.OS !== 'android') return;
    const antes = Dimensions.get('window').height;
    const sobe = Keyboard.addListener('keyboardDidShow', e => {
      // se o próprio sistema já encolheu a tela (aparelhos antigos), não soma de novo
      if (antes - Dimensions.get('window').height > 80) { setAlt(0); return; }
      // altura do teclado sem a barra de navegação do sistema (some com o espaço de baixo da tela)
      setAlt(Math.max(0, Math.round(e.endCoordinates.height)));
    });
    const desce = Keyboard.addListener('keyboardDidHide', () => setAlt(0));
    return () => { sobe.remove(); desce.remove(); };
  }, []);
  return alt;
}

/** 0.79 (texto 18): o teclado em qualquer sistema: altura e onde começa (topo, em pontos da tela). Fechado = { alt: 0, topo: 0 }.
 *  No iPhone avisa já no começo da animação (will); no Android quando termina (did). */
export function useTeclado() {
  const [st, setSt] = useState({ alt: 0, topo: 0 });
  useEffect(() => {
    if (Platform.OS === 'web') return;
    const ios = Platform.OS === 'ios';
    const abre = (e: any) => {
      const h = Math.max(0, Math.round(e?.endCoordinates?.height ?? 0));
      const topo = Math.round(e?.endCoordinates?.screenY ?? Dimensions.get('window').height - h);
      // descendo (fim da animação abaixo da tela) conta como fechado
      const fora = topo >= Math.max(Dimensions.get('screen').height, Dimensions.get('window').height) - 1;
      setSt(h > 0 && !fora ? { alt: h, topo } : { alt: 0, topo: 0 });
    };
    const fecha = () => setSt({ alt: 0, topo: 0 });
    const subs = [
      Keyboard.addListener(ios ? 'keyboardWillShow' : 'keyboardDidShow', abre),
      Keyboard.addListener(ios ? 'keyboardWillHide' : 'keyboardDidHide', fecha),
      ...(ios ? [Keyboard.addListener('keyboardWillChangeFrame', abre)] : []),
    ];
    return () => subs.forEach(s => s.remove());
  }, []);
  return st;
}

/** 0.79 (texto 18 B): nas listas e formulários que rolam, o teclado não cobre o campo:
 *  no iPhone a rolagem ganha o espaço do teclado e leva o campo para cima dele; arrastar para baixo até o teclado o fecha. */
export const ROLAGEM_TECLADO = Platform.OS === 'ios'
  ? ({ automaticallyAdjustKeyboardInsets: true, keyboardDismissMode: 'interactive' } as const)
  : ({} as const);
